import { ShoppingList, StoreList } from "../datatypes/ShoppingList";

import Reflux from "reflux";
import _ from "lodash";
import ListAction from "../actions/ListAction";
import * as TrackingUtil from "../utils/TrackingUtil";
import FeedbackActions from "../actions/FeedbackActions";
import ListService from "../services/ListService";
import { SessionStore } from "../uidispatcherapi/SessionStore";

let data: any;
let currentStoreId: any | undefined | null = null;

const PersonalListStore = Reflux.createStore({
    init() {
        data = this.getEmptyState();
        this.listenTo(ListAction.deleteList, this.deleteList);
        this.listenTo(ListAction.getRecentList, this.getRecentList);
        this.listenTo(SessionStore, this.onSessionStoreTrigger);
        this.onSessionStoreTrigger();
    },

    getEmptyState() {
        return {
            storelists: [],
            isLoadingStorelists: false
        };
    },

    onSessionStoreTrigger() {
        const storeId = SessionStore.getCustomerStore();
        const storeIdChanged = storeId !== currentStoreId;

        if (!SessionStore.loggedIn()) {
            return;
        }

        if (storeIdChanged && storeId) {
            data.storelists = [];
            this.fetchAllCountrySpecificStoreLists();
        }

        currentStoreId = storeId;
    },

    calcUniqAmount(list: ShoppingList) {
        list.uniqAmount = _.uniqBy(list.items, item => {
            return item.articleVariantId + (item.bundleId || "");
        }).length;
        return list;
    },

    setStoreList(lists: Array<StoreList>) {
        //CalcUniqItmes
        const storelists = _.map(lists, this.calcUniqAmount);
        _.sortBy(lists, list => list.name);

        data.storelists = storelists;
        this.trigger(data);
    },

    fetchAllCountrySpecificStoreLists() {
        const storeId = SessionStore.getCustomerStore();
        const country = SessionStore.getCountry();
        // TODO(EK): If Mario goes live in Germany, we probably need to change this check.
        if (!storeId || !SessionStore.loggedIn()) {
            return;
        }
        const self = this;
        const isEmployee = SessionStore.isEmployee();
        data.isLoadingStorelists = true;
        this.trigger(data);
        ListService.fetchAllCountrySpecificStoreLists(country, storeId, isEmployee)
            .then(self.getStoreListCompleted)
            .catch(self.getAllListsFailed);
    },

    async deleteList(listId: string) {
        try {
            await ListService.deleteListById(listId);
            FeedbackActions.NewFeedback("success", "EX_DELETE_LIST_SUCCESS", "", "", 2000, undefined);
            this.fetchAllCountrySpecificStoreLists();
        } catch (e) {
            this.trigger(data);
            FeedbackActions.NewFeedback("danger", "EX_DELETE_LIST_FAILED", "", "", 5000, undefined);
        }
    },

    getStoreListCompleted(response: { lists: Array<StoreList> }) {
        data.isLoadingStorelists = false;
        this.setStoreList(response.lists);
    },

    getAllListsFailed(e: any) {
        data = this.getEmptyState();
        this.trigger(data);
        TrackingUtil.trackUIError("PersonalListStore", "Fetching list items failed.", e);
        FeedbackActions.NewFeedback("danger", "EX_GET_ALL_LISTS_FAILED", "", "", 5000, undefined);
    },

    getAllStoreList() {
        return {
            storelists: data.storelists,
            isLoadingStorelists: data.isLoadingStorelists
        };
    },

    // For testing
    resetState() {
        data = this.getEmptyState();
    }
});

export default PersonalListStore;
